import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { AuthProvider } from "@/contexts/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AppLayout } from "@/components/AppLayout";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Library from "@/pages/Library";
import SOPEditor from "@/pages/SOPEditor";
import SOPViewer from "@/pages/SOPViewer";
import VersionHistory from "@/pages/VersionHistory";
import Approvals from "@/pages/Approvals";
import Notifications from "@/pages/Notifications";
import Compliance from "@/pages/Compliance";
import Ownership from "@/pages/Ownership";
import Admin from "@/pages/Admin";
import Profile from "@/pages/Profile";
import Chat from "@/pages/Chat";
import ExecuteSOP from "@/pages/ExecuteSOP";
import EmbedExecute from "@/pages/EmbedExecute";
import PdfImport from "@/pages/PdfImport";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            className: "!bg-[#0A0E1A]/90 !border !border-white/10 !text-white !rounded-2xl",
          }}
        />
        <Routes>
          {/* Public marketing landing */}
          <Route path="/" element={<Landing />} />

          {/* Sign-in (primary) + backward-compat alias */}
          <Route path="/signin" element={<Login />} />
          <Route path="/login" element={<Navigate to="/signin" replace />} />

          {/* Embed execute — auth required, no app chrome */}
          <Route
            path="/embed/execute/:id"
            element={
              <ProtectedRoute>
                <EmbedExecute />
              </ProtectedRoute>
            }
          />

          {/* App shell — everything below requires auth */}
          <Route
            element={
              <ProtectedRoute>
                <AppLayout />
              </ProtectedRoute>
            }
          >
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/library" element={<Library />} />
            <Route
              path="/create"
              element={
                <ProtectedRoute roles={["champion", "admin"]}>
                  <SOPEditor />
                </ProtectedRoute>
              }
            />
            <Route
              path="/import/pdf"
              element={
                <ProtectedRoute roles={["champion", "admin"]}>
                  <PdfImport />
                </ProtectedRoute>
              }
            />
            <Route path="/sops/:id" element={<SOPViewer />} />
            <Route path="/sops/:id/edit" element={<SOPEditor />} />
            <Route path="/sops/:id/execute" element={<ExecuteSOP />} />
            <Route path="/sops/:id/versions" element={<VersionHistory />} />
            <Route
              path="/approvals"
              element={
                <ProtectedRoute roles={["owner", "admin"]}>
                  <Approvals />
                </ProtectedRoute>
              }
            />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/compliance" element={<Compliance />} />
            <Route path="/ownership" element={<Ownership />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <Admin />
                </ProtectedRoute>
              }
            />
            <Route path="/profile" element={<Profile />} />
            <Route path="/chat" element={<Chat />} />
            <Route path="/chat/:sid" element={<Chat />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
